import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=f8976b16&scoped=true&"
import script from "./ContactCard.vue?vue&type=script&lang=js&"
export * from "./ContactCard.vue?vue&type=script&lang=js&"
import style0 from "./ContactCard.vue?vue&type=style&index=0&id=f8976b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8976b16",
  null
  
)

export default component.exports